const insertCssRuleItem = (item) => {
  document.styleSheets[0].insertRule(item);
};
/**
 * @param ele  element|element[]|selector
 */
const removeClass = (ele, classStr) => {
  if (ele instanceof Array) {
    [...ele].forEach((el) => (el.classList = [...el.classList].filter((item) => item != classStr).join(' ')));
    return [...ele];
  } else if (typeof ele === 'string') {
    [...document.querySelectorAll(ele)].forEach(
      (el) => (el.classList = [...el.classList].filter((item) => item != classStr).join(' '))
    );
    return [...document.querySelectorAll(ele)];
  } else {
    if (ele) ele.classList = [...ele.classList].filter((item) => item != classStr).join(' ');
    return [ele];
  }
};
const addClass = (ele, classStr) => {
  if (ele instanceof Array) {
    [...ele].forEach((el) => (el.classList = [...ele.classList, classStr].join(' ')));
  } else if (typeof ele === 'string') {
    [...document.querySelectorAll(ele)].forEach((el) => (el.classList = [...ele.classList, classStr].join(' ')));
  } else {
    if (ele) ele.classList = [...ele.classList, classStr].join(' ');
  }
};
const queryAll = (ele, selector) => {
  return Array.from(ele.querySelectorAll(selector));
};

/***
 * ## 支持多个相同事件的会, 如果不存在enable-multi-listener属性，则表示只支持第一个绑定事件的回调。
 * eg: ```<button type="button" enable-multi-listener />```
 */
const singleEleEvent = (ele, eventName, cb) => {
  if (ele) {
    try {
      if (ele.getAttribute?.('listener-lock')
        && !ele.hasAttribute('enable-multi-listener') // 未设置支持多个
      ) return;
      ele.setAttribute?.('listener-lock', 'done');
      ele.removeEventListener(eventName, cb);
    } catch (error) {
      console.log(error);
    }
    ele.addEventListener(eventName, cb);
  } else {
    console.error(ele);
  }
};
/**
 * @param ele  element|element[]|selector
 */
const addEvent = (ele, eventName, cb) => {
  if (ele instanceof Array) {
    [...ele].forEach((el) => singleEleEvent(el, eventName, cb));
  } else if (typeof ele === 'string') {
    [...document.querySelectorAll(ele)].forEach((el) => singleEleEvent(el, eventName, cb));
  } else {
    if (ele) singleEleEvent(ele, eventName, cb);
  }
};
class BaseClass extends HTMLElement {
  constructor() {
    super();
  }
  ADD_TO_CARD = '/cart/add.js'
  /***
  * add multi products at one time
  */
  async addMultiToCart(arr = []) {
    const itemsObj = [];
    arr.forEach((id, index) => {
      itemsObj.push(`items[${index}][quantity]=${1}`)
      itemsObj.push(`items[${index}][id]=${id}`)
      itemsObj.push(`items[${index}][properties][_bundle]=bundle`)

    })
    return await this.addToCart({ multi: itemsObj.join('&') })
  }
  /**
   *
   * @param {*} data
   * @returns
   */
  async addToCart(data) {
    if (!data.multi && !data.single) this.error('multi or single should be provided add least')
    let response = await fetch(this.ADD_TO_CARD, {
      method: 'POST',
      body: data.single ? data.single : data.multi,
      credentials: 'same-origin',
      headers: {
        'Content-Type': data.single ? 'application/json' : 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
    let res = await response.json()
    return res;
  }

  /***
   * add one product at one time
   */
  async addSingleToCart(variant_id, quantity = 1) {
    return await this.addToCart({
      single: JSON.stringify({ id: variant_id, quantity })
    })
  }

  error(msg) {
    if (msg) console.error(msg)
  }
  innerHTMLFn(msg, element) {
    element = this;
    if (!element.hasAttribute('data-done')) {
      element.innerHTML = msg
    }
  }
  // CART = '/cart.json'
  async getProduct({ handle }) {
    try {
      let response = await fetch(`/products/${handle}.json`, {
        method: 'GET',
        // body: JSON.stringify({ id: variant_id, quantity }),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
      let res = await response.json()
      return res;
    } catch (error) {
      this.error(error)
      if ([`127.0.0.1`, 'localhost'].indexOf(location.hostname) > -1) {
        return {
          "product": { "id": 7008096551012, "title": "Ode Brew Grinder Gen 2", "body_html": "\u003cp data-mce-fragment=\"1\"\u003eWe spent two years in development to bring you the next generation of our award-winning home brew grinder. From the finest pour-overs to the coarsest cold brews, your coffee will never be the same again.\u003c\/p\u003e\n\u003cp data-mce-fragment=\"1\"\u003eDesigned by Nick Terzulli, Fellow\u2019s VP of R\u0026amp;D and Certified Q Grader (the highest certification in sensory coffee assessment), Gen 2 Brew Burrs grind finer and with more precision. The broader grind range is exceptional for every brew method except espresso. With new anti-static technology for less grind mess, a redesigned load bin for smoother bean feeding, and an expanded 100 gram catch cup for batch brews, the next generation of grinding is here.\u003c\/p\u003e\n\u003cp data-mce-fragment=\"1\"\u003e\u003cstrong\u003eFeatures:\u00a0\u003c\/strong\u003e\u003c\/p\u003e\n\u003cul class=\"pdp_details__feature_list\"\u003e\n\u003cli\u003eNew best-in-class Gen 2 Brew Burrs\u003c\/li\u003e\n\u003cli\u003eNew anti-static technology for less grind mess\u003c\/li\u003e\n\u003cli\u003eNew 100 gram capacity\u003c\/li\u003e\n\u003cli\u003eNew load bin design for smoother bean feeding\u003c\/li\u003e\n\u003cli\u003e31 grind settings and guide\u003c\/li\u003e\n\u003cli\u003eQuiet grinding and automatic stop\u003c\/li\u003e\n\u003cli\u003eSingle dose loading for maximum freshness\u003c\/li\u003e\n\u003cli\u003eLow grind retention\u003c\/li\u003e\n\u003cli\u003eMagnetically aligned catch with easy pour fins\u003c\/li\u003e\n\u003cli\u003eGrinds knocker\u003c\/li\u003e\n\u003cli\u003eCompact footprint\u003c\/li\u003e\n\u003cli\u003eFree U.S. Domestic Shipping\u003c\/li\u003e\n\u003c\/ul\u003e\n\u003cul\u003e\u003c\/ul\u003e\n\u003cp data-mce-fragment=\"1\"\u003eEnjoy either a \u003ca href=\"https:\/\/fellowproducts.com\/pages\/warranty\"\u003e\u003cu data-mce-fragment=\"1\"\u003e2-year standard warranty\u003c\/u\u003e\u003c\/a\u003e, or a 3-year warranty if you \u003ca href=\"https:\/\/register.fellowproducts.com\/\"\u003eregister your grinder\u003c\/a\u003e.\u003c\/p\u003e", "vendor": "Fellow", "product_type": "Coffee Grinders", "created_at": "2022-10-26T09:20:09-07:00", "handle": "ode-brew-grinder-gen-2", "updated_at": "2023-09-27T06:11:56-07:00", "published_at": "2022-10-31T17:37:38-07:00", "template_suffix": "", "published_scope": "global", "tags": "Aftership_WB, and brand new burrs for an exceptional tasting cup., Details: Featuring new Gen 2 Brew Burrs for more precision and range., Electrics, less mess, nosearch-espresso, Not Coffee, not-spo-disabled, Ode Brew Grinder-FORECAST, Use: Grind, Vendor: Fellow, YGroup_OdeG2", "variants": [{ "id": 40978992463972, "product_id": 7008096551012, "title": "Matte Black \/ Gen 2 Brew Burrs", "price": "345.00", "sku": "D1211MB-US-SB", "position": 1, "compare_at_price": "345.00", "fulfillment_service": "manual", "inventory_management": "shopify", "option1": "Matte Black", "option2": "Gen 2 Brew Burrs", "option3": null, "created_at": "2022-10-26T09:20:10-07:00", "updated_at": "2023-09-27T06:11:56-07:00", "taxable": true, "barcode": "840228801641", "grams": 6577, "image_id": 30127644901476, "weight": 14.5, "weight_unit": "lb", "tax_code": "", "requires_shipping": true, "quantity_rule": { "min": 1, "max": null, "increment": 1 }, "quantity_price_breaks": [] }, { "id": 40978992496740, "product_id": 7008096551012, "title": "Matte Black \/ Upgraded SSP MP Brew Burrs (+ $150)", "price": "495.00", "sku": "D1211MB-US-S2", "position": 2, "compare_at_price": "495.00", "fulfillment_service": "manual", "inventory_management": "shopify", "option1": "Matte Black", "option2": "Upgraded SSP MP Brew Burrs (+ $150)", "option3": null, "created_at": "2022-10-26T09:20:10-07:00", "updated_at": "2023-09-27T06:11:56-07:00", "taxable": true, "barcode": "840228803584", "grams": 6577, "image_id": 30156301664356, "weight": 14.5, "weight_unit": "lb", "tax_code": "", "requires_shipping": true, "quantity_rule": { "min": 1, "max": null, "increment": 1 }, "quantity_price_breaks": [] }, { "id": 40978992529508, "product_id": 7008096551012, "title": "Matte White \/ Gen 2 Brew Burrs", "price": "345.00", "sku": "D1211MW-US-SB", "position": 3, "compare_at_price": "345.00", "fulfillment_service": "manual", "inventory_management": "shopify", "option1": "Matte White", "option2": "Gen 2 Brew Burrs", "option3": null, "created_at": "2022-10-26T09:20:10-07:00", "updated_at": "2023-09-27T06:11:56-07:00", "taxable": true, "barcode": "840228801689", "grams": 6577, "image_id": 30748078637156, "weight": 14.5, "weight_unit": "lb", "tax_code": "", "requires_shipping": true, "quantity_rule": { "min": 1, "max": null, "increment": 1 }, "quantity_price_breaks": [] }, { "id": 41257200549988, "product_id": 7008096551012, "title": "Matte White \/ Upgraded SSP MP Brew Burrs (+ $150)", "price": "495.00", "sku": "D1211MW-US-S2", "position": 4, "compare_at_price": "495.00", "fulfillment_service": "manual", "inventory_management": "shopify", "option1": "Matte White", "option2": "Upgraded SSP MP Brew Burrs (+ $150)", "option3": null, "created_at": "2022-11-25T12:40:57-08:00", "updated_at": "2023-09-27T06:11:56-07:00", "taxable": true, "barcode": "840228803591", "grams": 6577, "image_id": 30748078309476, "weight": 14.5, "weight_unit": "lb", "tax_code": "", "requires_shipping": true, "quantity_rule": { "min": 1, "max": null, "increment": 1 }, "quantity_price_breaks": [] }], "options": [{ "id": 8979926974564, "product_id": 7008096551012, "name": "Color", "position": 1, "values": ["Matte Black", "Matte White"] }, { "id": 8979927040100, "product_id": 7008096551012, "name": "Burrs", "position": 2, "values": ["Gen 2 Brew Burrs", "Upgraded SSP MP Brew Burrs (+ $150)"] }], "images": [{ "id": 30127644901476, "product_id": 7008096551012, "position": 1, "created_at": "2022-10-26T10:42:08-07:00", "updated_at": "2022-10-26T13:37:46-07:00", "alt": "Ode Brew Grinder Gen 2-Matte Black-Standard Brew Burrs-Fellow", "width": 1350, "height": 1350, "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0057\/6235\/1219\/products\/OdeGen2-Image1.png?v=1666816666", "variant_ids": [40978992463972] }, { "id": 30127644868708, "product_id": 7008096551012, "position": 2, "created_at": "2022-10-26T10:42:08-07:00", "updated_at": "2022-10-26T13:37:47-07:00", "alt": "Ode Brew Grinder Gen 2-Matte Black-Standard Brew Burrs-Fellow", "width": 1496, "height": 1496, "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0057\/6235\/1219\/products\/OdeGen2-Image2.png?v=1666816667", "variant_ids": [] }, { "id": 30127644999780, "product_id": 7008096551012, "position": 3, "created_at": "2022-10-26T10:42:08-07:00", "updated_at": "2022-10-26T13:37:48-07:00", "alt": "Ode Brew Grinder Gen 2-Matte Black-Standard Brew Burrs-Fellow", "width": 1534, "height": 1534, "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0057\/6235\/1219\/products\/OdeGen2-Image3.png?v=1666816668", "variant_ids": [] }, { "id": 30127644934244, "product_id": 7008096551012, "position": 4, "created_at": "2022-10-26T10:42:08-07:00", "updated_at": "2022-10-26T13:37:49-07:00", "alt": "Ode Brew Grinder Gen 2-Matte Black-Standard Brew Burrs-Fellow", "width": 1350, "height": 1350, "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0057\/6235\/1219\/products\/OdeGen2-Image4.png?v=1666816669", "variant_ids": [] }, { "id": 30355247857764, "product_id": 7008096551012, "position": 5, "created_at": "2022-12-08T11:28:30-08:00", "updated_at": "2022-12-08T12:36:50-08:00", "alt": "Ode Brew Grinder Gen 2-Matte Black-Gen 2 Brew Burrs-Fellow", "width": 3000, "height": 3000, "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0057\/6235\/1219\/products\/2.png?v=1670531810", "variant_ids": [] }, { "id": 30355247464548, "product_id": 7008096551012, "position": 6, "created_at": "2022-12-08T11:28:18-08:00", "updated_at": "2022-12-08T12:36:51-08:00", "alt": "Ode Brew Grinder Gen 2-Matte Black-Gen 2 Brew Burrs-Fellow", "width": 3000, "height": 3000, "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0057\/6235\/1219\/products\/6.png?v=1670531811", "variant_ids": [] }, { "id": 30127645032548, "product_id": 7008096551012, "position": 7, "created_at": "2022-10-26T10:42:08-07:00", "updated_at": "2022-12-08T11:28:35-08:00", "alt": "Ode Brew Grinder Gen 2-Matte Black-Upgraded SSP MP Brew Burrs (+ $186)-Fellow", "width": 1350, "height": 1350, "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0057\/6235\/1219\/products\/OdeGen2-Image5.png?v=1670527715", "variant_ids": [] }, { "id": 30128231972964, "product_id": 7008096551012, "position": 8, "created_at": "2022-10-26T13:04:03-07:00", "updated_at": "2022-12-08T11:28:35-08:00", "alt": "Ode Brew Grinder Gen 2-Matte Black-Standard Brew Burrs-Fellow", "width": 1496, "height": 1496, "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0057\/6235\/1219\/products\/OdeGen2-white-Image2.png?v=1670527715", "variant_ids": [] }, { "id": 30128232005732, "product_id": 7008096551012, "position": 9, "created_at": "2022-10-26T13:04:03-07:00", "updated_at": "2022-12-08T11:28:35-08:00", "alt": "Ode Brew Grinder Gen 2-Matte Black-Standard Brew Burrs-Fellow", "width": 1534, "height": 1534, "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0057\/6235\/1219\/products\/OdeGen2-white-Image3.png?v=1670527715", "variant_ids": [] }, { "id": 30128232136804, "product_id": 7008096551012, "position": 10, "created_at": "2022-10-26T13:04:03-07:00", "updated_at": "2022-12-08T11:28:35-08:00", "alt": "Ode Brew Grinder Gen 2-Matte Black-Standard Brew Burrs-Fellow", "width": 1350, "height": 1350, "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0057\/6235\/1219\/products\/OdeGen2-white-Image4.png?v=1670527715", "variant_ids": [] }, { "id": 30151875461220, "product_id": 7008096551012, "position": 11, "created_at": "2022-10-31T17:54:50-07:00", "updated_at": "2022-12-08T11:28:35-08:00", "alt": "Ode Brew Grinder Gen 2-Matte White-Gen 2 Brew Burrs-Fellow", "width": 3000, "height": 3000, "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0057\/6235\/1219\/products\/OdeBrewGrinderGen2MatteWhite_3.png?v=1670527715", "variant_ids": [] }, { "id": 30156301664356, "product_id": 7008096551012, "position": 12, "created_at": "2022-11-01T09:13:37-07:00", "updated_at": "2022-12-08T11:28:35-08:00", "alt": "Ode Brew Grinder Gen 2-Matte Black-Upgraded SSP MP Brew Burrs (+ $150)-Fellow", "width": 3000, "height": 3000, "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0057\/6235\/1219\/products\/4.png?v=1670527715", "variant_ids": [40978992496740] }, { "id": 30312649424996, "product_id": 7008096551012, "position": 13, "created_at": "2022-11-25T12:33:22-08:00", "updated_at": "2022-12-08T11:28:35-08:00", "alt": "Ode Brew Grinder Gen 2-Matte Black-Gen 2 Brew Burrs-Fellow", "width": 3000, "height": 3000, "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0057\/6235\/1219\/products\/4_1.png?v=1670527715", "variant_ids": [] }, { "id": 30748078309476, "product_id": 7008096551012, "position": 14, "created_at": "2023-03-07T16:11:39-08:00", "updated_at": "2023-03-08T12:36:39-08:00", "alt": "Ode Brew Grinder Gen 2-Matte White-Upgraded SSP MP Brew Burrs (+ $150)-Fellow", "width": 3000, "height": 3000, "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0057\/6235\/1219\/products\/4_d02f18d8-1ef0-42ee-a7c2-159ffd6b4879.png?v=1678307799", "variant_ids": [41257200549988] }, { "id": 30748078637156, "product_id": 7008096551012, "position": 15, "created_at": "2023-03-07T16:11:52-08:00", "updated_at": "2023-03-08T12:36:40-08:00", "alt": "Ode Brew Grinder Gen 2-Matte White-Gen 2 Brew Burrs-Fellow", "width": 3000, "height": 3000, "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0057\/6235\/1219\/products\/1_90564a96-d851-43e6-8c8d-74ccbc07a2f0.png?v=1678307800", "variant_ids": [40978992529508] }], "image": { "id": 30127644901476, "product_id": 7008096551012, "position": 1, "created_at": "2022-10-26T10:42:08-07:00", "updated_at": "2022-10-26T13:37:46-07:00", "alt": "Ode Brew Grinder Gen 2-Matte Black-Standard Brew Burrs-Fellow", "width": 1350, "height": 1350, "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0057\/6235\/1219\/products\/OdeGen2-Image1.png?v=1666816666", "variant_ids": [40978992463972] } }
        }
      }
    }

  }
  connectedCallback() {
    this.init();
  }
  init() { }
  siblings(liEl) {
    return [...liEl.parentElement.children].filter((li, index) => liEl !== li);
  }
  /**
   *
   * @param {*} liEl
   * @param {*} tagStr  指定元素tag，非必传
   * @returns
   */
  index(liEl, tagStr) {
    return eleIndex(liEl, tagStr);
  }
  /**
   * active current li element
   */
  activeCurrentEl(liEl) {
    this.siblings(liEl).forEach((li) => {
      this.removeClass(li, 'active');
    });
    //current-img
    this.addClass(liEl, 'active');
  }
  isMobile() {
    return window.innerWidth < 750;
  }
  createEle(eleStr = 'div') {
    return document.createElement(eleStr);
  }

  /***
   * shopify price = num = actual display price * 100
   */
  moneyFn(num) {
    if (!num) return 0;
    if (num instanceof Array) {
      num = num.reduce((res, item) => {
        res += item;
        return res;
      }, 0);
    }
    return `$${(num / 100).toFixed(2)}`;
  }
  click(el, cb) {
    this.addEvent(el, 'click', cb);
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  queryAll = queryAll
  addEvent(ele, eventName, cb) {
    addEvent(ele, eventName, cb);
  }
  /**
   * ele 元素是否包含`classStr` class
   * @param {*} ele
   * @param {*} classStr
   * @returns
   */
  hasClass(ele, classStr) {
    if (!ele) return false;
    return [...ele.classList].includes(classStr);
  }
  /**
   *  # add class
   * @param {*} ele
   * @param {*} classStr
   */
  addClass(ele, classStr) {
    addClass(ele, classStr);
  }
  removeClass(ele, classStr) {
    removeClass(ele, classStr);
  }
  queryAll(ele, selector) {
    return Array.from(ele.querySelectorAll(selector));
  }
  isMobile() {
    return window.innerWidth < 750;
  }
}

class CButton extends BaseClass {
  constructor() {
    super();
  }
  initHtml() {

  }
  iconLoading = `<svg class="icon icon-loading spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100" height="100" preserveAspectRatio="xMidYMid meet" style="width: 100%; height: 100%; transform: translate3d(0px, 0px, 0px); content-visibility: visible;"><defs><clipPath id="__lottie_element_1279"><rect width="100" height="100" x="0" y="0"></rect></clipPath></defs><g clip-path="url(#__lottie_element_1279)"><g transform="matrix(0.19265000522136688,0,0,0.19265000522136688,52.332401275634766,56.685401916503906)" opacity="0.1" style="display: block;"><g opacity="1" transform="matrix(1,0,0,1,-16,-36)"><path stroke-linecap="butt" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="4" stroke="rgb(255,255,255)" stroke-opacity="1" stroke-width="46" d=" M0,-223.57000732421875 C123.38829040527344,-223.57000732421875 223.57000732421875,-123.38829040527344 223.57000732421875,0 C223.57000732421875,123.38829040527344 123.38829040527344,223.57000732421875 0,223.57000732421875 C-123.38829040527344,223.57000732421875 -223.57000732421875,123.38829040527344 -223.57000732421875,0 C-223.57000732421875,-123.38829040527344 -123.38829040527344,-223.57000732421875 0,-223.57000732421875z"></path></g></g><g transform="matrix(0.19265000522136688,0,0,0.19265000522136688,52.332401275634766,56.685401916503906)" opacity="1" style="display: block;"><g opacity="1" transform="matrix(1,0,0,1,-16,-36)"><path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="4" stroke="rgb(255,255,255)" stroke-opacity="1" stroke-width="46" d=" M55.606998443603516,-216.58700561523438 C152.1320037841797,-191.84100341796875 223.57000732421875,-104.19400024414062 223.57000732421875,0 C223.57000732421875,94.33000183105469 165.01800537109375,175.0970001220703 82.30799865722656,207.90699768066406"></path></g></g></g></svg>`;
  textContent = ''
  initEvent() {
    this.addEvent(this, 'click', () => {
      this.loading()
    })

  }
  loading() {
    this.textContent = this.innerHTML
    this.innerHTML = this.iconLoading
  }
  reset() {
    this.innerHTML = this.textContent
  }

  connectedCallback() {
    this.initHtml()
    this.initEvent()
  }
}
if (!customElements.get(`c-button`)) {
  customElements.define(`c-button`, CButton);
}
class CProductCard extends BaseClass {
  constructor() {
    super();
  }
  subscriptionData = null;
  radioContianer = null;
  radioCheckedSvgEl = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.5 12.55L9.8 15.85L17.5 8.14996" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`
  radioSvgEl = `<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1.57153" width="22" height="22" rx="11" stroke="#272729" stroke-width="2"/>
    </svg>`

  currency = '$'
  product = null;
  supportOptionPillFormat = false
  getQuantityHtml() {
    return `<quantity-input class="quantity" :class="XBLOOM3.IS_MOBILE?'xbloom-text-12':'xbloom-text-14'">
                      <button class="quantity__button no-js-hidden" name="minus" type="button">
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
</path></svg>
                      </button>
                      <input
                        class="quantity__input"
                        :class="XBLOOM3.IS_MOBILE?'xbloom-text-12':'xbloom-text-14'"
                        type="number"
                        name="quantity"
                        id="Quantity-123"
                        data-cart-quantity="1"
                        data-min="1"
                        min="1"
                        step="1"
                        value="1"
                      >
                      <button class="quantity__button no-js-hidden" name="plus" type="button">
                           <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
</path></svg>
                      </button>
                    </quantity-input>`
  }
  initHtml(data) {
    let currency = this.getAttribute('data-currency');
    this.supportOptionPillFormat = this.hasAttribute('data-enable-pills-selector');
    if (currency.indexOf('{{') == -1) this.currency = currency;
    let p = data.product
    this.product = data.product;
    // let subscriptions = '';
    if ('3ww-water-enhancer' == this.getAttribute('data-handle')) {
      //
    }
    let optionsStr = data.product.variants.map(item => {
      return `<option  value="${item.id}">${item.title} </option>`
    }).join('');
    let lebelRenderFn = (item, itemIndex) => {
      return item.values.map((v, index) => {
        return `<input type="radio" ${index == 0 ? 'checked' : ''}  class="c-pill-option" id="template--${v}-${itemIndex}-${index}" name="${item.name}_${itemIndex}_${this.product.id}" data-name="${item.name}" value="${v}" ><label for="template--${v}-${itemIndex}-${index}">${v}</label>`
      }).join('')
    }
    let lablelStr = this.product.options.map((item, itemIndex) => {
      return ` <fieldset class="c-pills"><span class="form__label" data-label="${item.name}">${item.name}: ${item.values[0]}</span>${lebelRenderFn(item, itemIndex)}</fieldset>`
    }).join('');
    // 只显示size
    // let showOptionOnly = this.hasAttribute('data-show-option-only')
    let selectHtml = this.product.options.length == 1 ? `
            <div class="">
                <div class="option-container">
                ${lablelStr}
                </div>
              </div>
        `: `<div class="p-b-5">
            <div class="c-select">
                <select name="v-id" class="set-line-1" >
                ${optionsStr}
                </select>
            </div>
        </div>`
    let hiddenHtml = ``;
    //     console.log("this.product.variants.length", this.product.variants.length)
    //     console.log("this.product.variants[0].title", this.product.variants[0]?.title)
    //     console.log("this.product.tags", this.product.tags)
    //     console.log("this.product.variants[0].id", this.product.variants[0].id)
    //     console.log("this.product.title", this.product.title)
    //     console.log("this.product.handle", this.product.handle)
    //     console.log("this.product.options[0].name", this.product.options[0]?.name)
    //     console.log("this.product.options[0].values", this.product.options[0]?.values)
    //     console.log("this.product.options[0].price", this.product.options[0]?.price)
    //     console.log("this.product.options[0].compare", this.product.options[0]?.compare_at_price)
    // console.log("product title", p.title)

    if (this.product.variants.length == 1) {
      if (this.product.variants[0].title == 'Default Title') selectHtml = ``
      hiddenHtml = `<input type="hidden" name="v-id-${this.product.id}" value="${p.variants[0].id}" />`
    }

    let img = p.images.find(item => {
      if (!item.alt) return true;
      return item.alt?.indexOf?.('#HIDE_IN_DETAIL') == -1
    })
    if (!img) img = p.image

    let price = parseFloat(p.variants[0].price)
    let compare_at_price = `${this.currency}${(price).toFixed(2)}`

    // 因默认选中one time, 再次
    let price1 = price
    let isGift = this.hasAttribute('data-enable-gift')
    let isBundle1 = this.hasAttribute('data-enable-bundle1')
    if (isGift) {
      price1 = (price1 * 0);
    } else {
      if (isBundle1) {
        if (this.product?.title == 'xBloom Coffee Machine') {
          price1 = price1 - 120;
        } else {
          price1 = price1 * 0;
        }
      } else {
        price1 = (price1 - 4);
      }
    }
    if (p.handle == 'reusable-dripper-2') { compare_at_price = `${this.currency}29.00` }
    if (p.handle == '8x-xpod-starter-pack') { compare_at_price = `${this.currency}13.00` }
    let formatPrice = `${this.currency}${price1.toFixed(2)}`
    this.innerHTML = `<div>
            <div class="c-img-size-100" :class="XBLOOM3.IS_MOBILE?'c-img-mobile':'c-img-pc'">
                <img src="${img.src}" alt="${p.title}">
            </div>
            <div style="max-width: calc(100% - 100px - var(--c-space-16));flex:1;">
                <h3 class="c-h3 "><a href="${this.closest('c-product-card-group').hasAttribute('no-link') ? 'javascript:void(0)' : `/products/${p.handle}`}">${p.title}</a></h3>
                  ${this.hasAttribute('data-disable-price') ? '' : ` <div class="p-t-5 p-b-5">
                  <span class="c-price ">${formatPrice} </span>
                  <span class="c-price  c-compare-at-price">${compare_at_price}</span></div>`}
                  ${this.hasAttribute('data-enable-desc') ? `<div class="c-desc">${this.innerHTML}</div>` : ''}
                  ${selectHtml}
                  ${hiddenHtml}
                  <div>
                     ${this.showAddButton ? `<c-button class="c-btn" enable-multi-listener>Add</c-button>` : ''}
                  </div>
            </div>
        </div>`
    this.submitBtn = this.querySelector('c-button')

    if (this.closest('c-product-card-group')?.hasAttribute('data-enable-single-select')) {
      this.radioContianer = this.querySelector('.c-h3 >.c-radio-container')
      if (!this.radioContianer) {
        this.radioContianer = document.createElement('div')
        if (this.hasAttribute('data-enable-first-selected')) this.radioContianer.setAttribute('data-checked', 'true')
        this.radioContianer.classList = 'c-radio-container c-pointer-action'
        if (this.hasAttribute('data-enable-first-selected')) {
          this.radioContianer.innerHTML = ''
        } else {
          this.radioContianer.innerHTML = ''
        }

        this.querySelector('.c-h3').append(this.radioContianer)
      }
    }
    let radioEl = this.querySelector('fieldset input[type="radio"]')
    if (radioEl) this.change({
      target: radioEl
    })

  }
  submitBtn = null
  isMachinePage = false;
  currentVariant = null;
  enableQuantity = false;
  /**
   * 更新c-product-card 元素的价格，图片，更新c-product-card-group 组件
  */
  change(evt) {
    let selectedLabel = this.supportOptionPillFormat ? Array.from(this.querySelectorAll('.c-pills input[type="radio"]:checked')).map(item => item.value).join(' / ') : ''
    if (this.supportOptionPillFormat) {
      let labelEl = evt.target.closest('fieldset').querySelector('.form__label');
      labelEl.innerHTML = `${labelEl.dataset.label}: ${evt.target.dataset.label || evt.target.value}`
    }
    let f = this.currentVariant = this.product.variants.find(item => {
      if (this.supportOptionPillFormat) {
        return selectedLabel == item.title
      }
      return item.id == evt.target.value
    })
    if(!f){
      f = this.currentVariant =  this.product.variants[0]
    }
    let compare_at_price = f.compare_at_price;
    let price = f.price;
    if (!compare_at_price) {
      compare_at_price = f.price
      let isGift = this.hasAttribute('data-enable-gift')
      let isBundle1 = this.hasAttribute('data-enable-bundle1')
      if (isGift) {
        price = 0;
      } else {
        if (isBundle1) {
          if (this.product.title == 'xBloom Coffee Machine') {
            price = (price - 120);
          } else {
            price = (price * 0);
          }

        } else {
          price = (price - 4);
        }
      }
    }
    if (!this.hasAttribute('data-disable-price')) { // 允许展示价格
      this.querySelector('.c-price').innerHTML = this.currency + parseFloat(`${price}`).toFixed(2)
      this.querySelector('.c-compare-at-price').innerHTML = !compare_at_price || compare_at_price == price ? '' : (this.currency + parseFloat(compare_at_price).toFixed(2))
    }

    let url = this.product.images.find(item => f.image_id == item.id)?.src
    let imgEl = this.querySelector('.c-img-size-100 img');

    if (imgEl && !imgEl.hasAttribute('data-first-img')) {
      let first = this.querySelector('.c-img-size-100 img').getAttribute('src');
      imgEl.setAttribute('data-first-img', first)
    }
    if (!url) url = imgEl.getAttribute('data-first-img')
    imgEl.setAttribute('src', url)
    setTimeout(() => {
      this.closest('c-product-card-group').updateEventCustomization?.()
    }, 500)

  }

  // 获取c-product-card 当前数据
  getCurrentSelected() {
    let id = this.querySelector(`[name="v-id-${this.product?.id}"]`)?.value ?? this.currentVariant?.id ?? this.product?.variants?.[0]?.id
    let purchaseMethod = document.querySelector('[name="purchase_method"]:checked')?.value
    if(!this.product) this.product = JSON.parse(this.getAttribute('product_str'))
    let sellingPlanDiscount = null;
    let sellingPlanType = null;
    let sellingPlanEl = null;
    let sellingPlanLabel = null;
    this.enableQuantity = this.hasAttribute('data-enable-quantity') // 是否启用数量
    let sellingPlanId = this.getAttribute('data-enable-subscription')
    if (!this.closest('c-product-card-group').hasAttribute('data-no-subcription')) {
      sellingPlanId = ''
    }

    let currentv = this.product?.variants?.filter?.(item => item.id == id)?.[0]
    if (!currentv) {
      currentv = this.product?.variants[0]
    }
    let currentPrice = currentv?.price ?? '0'
    let comparePrice = currentv?.compare_at_price ?? '0'
    comparePrice = currentPrice
    let isGift = this.hasAttribute('data-enable-gift')
    let isBundle1 = this.hasAttribute('data-enable-bundle1')
    if (isGift) {
      currentPrice = parseFloat(currentPrice);
    } else {
      if (isBundle1) {
          if(comparePrice=='0.00'&&this.product){
           comparePrice = currentv?.compare_at_price
          }
       
        if (this.product?.title == 'xBloom Coffee Machine') {
          currentPrice = parseFloat(currentPrice) - 120;
        } else {
          currentPrice = parseFloat(currentPrice) * 0;
        }
      } else {
        currentPrice = parseFloat(currentPrice) - 4;
      }
    }

    return {
      enableSellplan: !!sellingPlanId, // 支持 bundle 订阅50%
      id,
      sellingPlanId,
      sellingPlanLabel,
      sellingPlanDiscount,
      handle: this.product?.handle,
      sellingPlanType,
      title: this.querySelector('.c-h3')?.textContent ?? this.product?.title,
      price: currentPrice,
      compare_at_price: comparePrice,
      options: Array.from(this.querySelectorAll('.c-pills .c-pill-option:checked')).map(item => {
        return {
          value: item.value,
          option: item.getAttribute('name')
        }
      })
    }
  }
  initEvent() {
    this.addEvent(this, 'change', this.change)
    this.addEvent(this.submitBtn, 'click', async () => {
      try {
        let id = this.getCurrentSelected().id;
        let res = await this.addSingleToCart(id)
        this.submitBtn.reset?.()
        /**
         * @TODO: how to update cart after update to cart
         *
         */
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: id, cartData: res });

      } catch (error) {
        this.submitBtn.reset?.()
      }
    })

    if (this.radioContianer) {

      this.addEvent(this.radioContianer, 'click', () => {
        //        if (!this.closest('c-product-card-group').hasAttribute('data-enable-multi-select')) this.closest('c-product-card-group').unselectCardExceptIndex(this.index(this, 'c-product-card'))
        //        this.updateActive(this.radioContianer.getAttribute('data-checked') != 'true')
        //        this.closest('c-product-card-group').updateEventCustomization?.()
      })
      this.closest('c-product-card-group').updateEventCustomization?.()


    }
  }
  /**
   * 按flag 值更新card 选择器的(选择icon)状态
   * @param {*} flag
   */
  updateActive(flag) {
    this.radioContianer.setAttribute('data-checked', 'true')
    this.radioContianer.innerHTML = ''
  }
  /***
   * 取消选择
   */
  unselectCard() {
    this.updateActive(false)
  }

  showAddButton = true
  async connectedCallback() {
    if (!this.getAttribute('data-handle')) return this.error(`data-handle not set for c-product-card`)
    if (this.hasAttribute('data-disable-add')) this.showAddButton = false;                          // 不显示加购按钮
    if (this.hasAttribute('data-subscription-json')) this.subscriptionData = JSON.parse(this.dataset.subscriptionJson)
    let res = await this.getProduct({
      handle: this.getAttribute('data-handle')
    })
    this.setAttribute('product_str',JSON.stringify(res.product)) ;
    this.initHtml(res)
    this.initEvent()

  }
}
if (!customElements.get(`c-product-card`)) {
  customElements.define(`c-product-card`, CProductCard);
}
class CProductCardGroup extends BaseClass {
  constructor() {
    super();
  }
  /**
    依据主商品的one time和订阅选择，为支持订阅和one time 购买的group 动态改变副标题
   */
  collapseIconEl = null
  downArrowSvgEl = `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.1606 12.4393C27.7464 13.0251 27.7464 13.9749 27.1606 14.5607L18.1606 23.5607C17.5749 24.1464 16.6251 24.1464 16.0393 23.5607L7.03932 14.5607C6.45353 13.9749 6.45353 13.0251 7.03932 12.4393C7.6251 11.8536 8.57485 11.8536 9.16063 12.4393L17.1 20.3787L25.0393 12.4393C25.6251 11.8536 26.5748 11.8536 27.1606 12.4393Z" fill="#272729"/>
        </svg>
    `

  currency = '$'
  titleEl = null;
  subTitleEl = null;
  product = null;
  supportSingleSelect = false; // 是否支持单选
  productBundle2 = ['reusable-dripper-2', '8x-xpod-starter-pack', 'xbloom-original'];
  initHtml() {
    this.supportSingleSelect = this.hasAttribute('data-enable-single-select')

    this.submitBtn = this.querySelector('c-button')
    if (this.dataset.title || this.dataset.subTitle) {
      const titleContainer = document.createElement('div')
      const IS_MOBILE = window.innerWidth < 1050
      if (this.dataset.title) {
        this.titleEl = document.createElement('div')

        this.titleEl.classList = IS_MOBILE ? 'c-group-sub-title ' : 'c-group-sub-title'


        this.titleEl.innerHTML = this.dataset.title
        titleContainer.appendChild(this.titleEl)
        if (this.hasAttribute('data-enable-collapse')) {
          this.collapseIconEl = document.createElement('div')
          this.collapseIconEl.innerHTML = this.downArrowSvgEl
          this.collapseIconEl.classList = 'c-collapse-icon c-pointer-action'
          this.titleEl.append(this.collapseIconEl)
        }
      }
      if (this.dataset.subTitle) {
        this.subTitleEl = document.createElement('div')
        this.subTitleEl.classList = IS_MOBILE ? 'c-group-sub-title' : 'c-group-sub-title'
        this.subTitleEl.innerHTML = this.dataset.subTitle
        titleContainer.appendChild(this.subTitleEl)
      }
      if (!this.querySelector('.c-group-sub-title')) this.prepend(titleContainer)
    }
  }
  submitBtn = null
  change(evt) {

  }

  getCurrentSelected() {
    let checkedList = Array.from(this.querySelectorAll('c-product-card'));
    if (this.supportSingleSelect) {
      checkedList = Array.from(this.querySelectorAll('c-product-card .c-radio-container[data-checked="true"]'))
        .map(item => item.closest('c-product-card'))
    }
    return checkedList
      .map(item => {
        return item.getCurrentSelected().id
      })
  }
  getCurrentSelectedObjs() {
    let _this = this;
    //    let isBunle2 = document.querySelectorAll('variant-radios input[name="Type"]')?.[1]?.checked;
    let checkedList = Array.from(this.querySelectorAll('c-product-card'));
    //    if (checkedList.length >= 4 && isBunle2) {
    //      checkedList = checkedList.filter(item => {
    //        return _this.productBundle2.indexOf(item?.product?.handle) == -1
    //      })
    //    }
    return checkedList
      .map(item => {
        return item.getCurrentSelected()
      })
  }
  /**
   * 不同group的事件监听
   */
  updateEventCustomization() {
    let _this = this;
    let items = Array.from(document.querySelectorAll('c-product-card-group')).map(item => item.getCurrentSelectedObjs()).flat(1)
    let total = 0, compareAtTotal = 0;
    let currentP = "", currentC = "";
    let isOnlyMain = items.length == 2
    if (!isOnlyMain) {
      document.querySelector('.group-selected-result').innerHTML = 'Selected: ' + (items.map((item, index) => {
        total += item.price
        compareAtTotal += parseFloat(item.compare_at_price ? item.compare_at_price : item.price)

        return '"' + item.title + ' x1"'
      }).join(', ')).replace(';,', ';');

    } else {
      let mainP = document.querySelector('product-info-encounter').getCurrentObj();
      items.unshift(mainP);

      let otherTotal = 0;

      document.querySelector('.group-selected-result').innerHTML = 'Selected: ' + (items.map((item, index) => {
        if (index !=0 && item?.price != 0) {
            otherTotal += item?.price
        }
        // console.log("price", item?.price);
        return '"' + item.title + ' x1"';
      }).join(', ')).replace(';,', ';');

      total = mainP?.price * 12;
      // console.log("total", total)
      compareAtTotal = otherTotal + parseFloat(`${total}`);
    }

    currentP = total.toFixed(2)
    currentC = compareAtTotal.toFixed(2)

    let currency = this.querySelector('c-product-card').dataset.currency;

    let originalPrice = `<span>${currency}${currentC}</span>`
    document.querySelector('.product-form__buttons [type="submit"]').innerHTML = `<span>Add to cart</span>
          <div class="loading-overlay__spinner hidden">
            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>`
    let subtotal = document.createElement('div')
    subtotal.innerHTML = `<span>Subtotal: <strong>${currency}${currentP} </strong> ${originalPrice}</span>`
    document.querySelector('.group-selected-result').append(subtotal)

  }
  initEvent() {
    let this_ = this;
    if (this_.closest('product-info-encounter')) {
      this_.closest('product-info-encounter').addEventListener('change', (evt) => {
        this_.updateEventCustomization()
      })
    }
    this.addEvent(this.submitBtn, 'click', async () => {
      try {
        const res = await this.addMultiToCart(this.getCurrentSelected())
        this.submitBtn.reset?.()
      } catch (error) {
        this.submitBtn.reset?.()
      }

    })
  }
  submitBtn = null
  async connectedCallback() {
    this.initHtml()
    this.initEvent()
  }
  /**
   *  取消选择除 `index` 之外的对应元素
   * @param {*} index 
   */
  unselectCardExceptIndex(index) {
    Array.from(this.querySelectorAll('c-product-card'))
      .forEach((el, elIndex) => {
        if (elIndex !== index) {
          el.unselectCard()
        }
      })
  }
}
if (!customElements.get(`c-product-card-group`)) {
  customElements.define(`c-product-card-group`, CProductCardGroup);
}
